import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import NomeUnidade from "../../../../UI/NomeUnidade";
import FormDetalheAlt from "../FormDetalheAlt/index";
import utils from "../../../utils/utils";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            user: {},
            metas: null
        }
    }

    async componentDidMount() {
       await this.consultarMetas();
    }

    consultarMetas = async () => {
        let id = window.location.pathname;
        id = id.split("mensais-")[1];
        let metas = await api.get(`/sti/metas/${id}`);
        metas = metas.data.metas;
        this.setState({ metas: metas });
    }

    onSubmit = async (event) => {

        try {

            event.preventDefault();
            
            let { numeroAtendimento, horasTecnicas, calibracoes, ensaios, relatoriosELaudos, receita, despesa } = event.target;
            let { mediaHH, totalHH, valorHora, receitaPrevista } = event.target;
            
            numeroAtendimento = [...numeroAtendimento].map(valor => Number(valor.value));
            horasTecnicas     = horasTecnicas && [...horasTecnicas].map(valor => Number(valor.value));
            calibracoes       = calibracoes && [...calibracoes].map(valor => Number(valor.value));
            ensaios           = ensaios && [...ensaios].map(valor => Number(valor.value));
            relatoriosELaudos = relatoriosELaudos && [...relatoriosELaudos].map(valor => Number(valor.value));
            receita           = [...receita].map(valor => Number(valor.value));
            despesa           = [...despesa].map(valor => Number(valor.value));

            let totalNumeroAtendimento = numeroAtendimento.reduce((acc, atual) => acc + atual, 0);
            let totalHorasTecnicas     = horasTecnicas && horasTecnicas.reduce((acc, atual) => acc + atual, 0);
            let totalCalibracoes       = calibracoes && calibracoes.reduce((acc, atual) => acc + atual, 0);
            let totalEnsaios           = ensaios && ensaios.reduce((acc, atual) => acc + atual, 0);
            let totalRelatoriosELaudos = relatoriosELaudos && relatoriosELaudos.reduce((acc, atual) => acc + atual, 0);
            let totalReceita           = receita.reduce((acc, atual) => acc + atual, 0);
            let totalDespesa           = despesa.reduce((acc, atual) => acc + atual, 0);

            totalHH = Number(mediaHH.value) * totalNumeroAtendimento;
            //receitaPrevista = Number(valorHora.value) * totalHH;

            let { 
                linhaAtuacao, 
                categoria, 
                cr, 
                produtoNacional, 
                setor, 
                comentario,
                metaEmpresasAtendidas,
                metaAtendimentos,
                //mediaHH,
                //totalHH,
                totalEnsaiosCalibracoes,
                totalLaudosRelatorios,
                //valorHora,
                //receitaPrevista,
                colaborador
            } = event.target;

            let { 
                Sigla,
                Produto, 
                DescritivoProduto, 
                Objetivo, 
                ConteudoProgramatico, 
                ResultadosEsperados, 
                Beneficios, 
                ContaContabilId, 
                Nome, 
                Codigo,
                CodigoMascara,
                NomeNivel4,
                NomeNivel5
            } = this.state.metas;

            let cadastro = {
                linhaAtuacao: linhaAtuacao.value,
                categoria: categoria.value,
                cr: cr.value,
                produtoNacional: produtoNacional.value,
                comentario: comentario.value,
                metaEmpresasAtendidas: Number(metaEmpresasAtendidas.value),
                metaAtendimentos: Number(metaAtendimentos.value),
                mediaHH: Number(mediaHH.value),
                totalHH: totalHH,
                totalEnsaiosCalibracoes: Number(totalEnsaiosCalibracoes.value),
                totalLaudosRelatorios: Number(totalLaudosRelatorios.value),
                valorHora: Number(valorHora.value),
                receitaPrevista: Number(receitaPrevista.value),
                Sigla,
                Produto, 
                DescritivoProduto, 
                Objetivo, 
                ConteudoProgramatico, 
                ResultadosEsperados, 
                Beneficios, 
                ContaContabilId, 
                Nome, 
                Codigo,
                CodigoMascara,
                NomeNivel4,
                NomeNivel5,
                numeroAtendimento, 
                horasTecnicas, 
                calibracoes,
                ensaios,
                relatoriosELaudos,
                receita, 
                despesa
            }

            let valores = {
                totalCalibracoes, 
                totalEnsaios, 
                totalRelatoriosELaudos,
                totalNumeroAtendimento,
                totalHorasTecnicas
            } 

            let verif = [linhaAtuacao.value, categoria.value, produtoNacional.value];
            verif.map(v => {
                if(v.includes("Escolha")) throw new Error("erro Sigla");
            });

            if(utils.verificaCadastro(categoria.value, valores)) {

                let status = await api.put(`/sti/metas/${this.state.metas._id}`, cadastro);
                if(status.data.status === "ok") window.showNotification('Editado com sucesso', 'success');
                else window.showNotification(status.data.status || 'Erro na atualização', 'danger');
                
                await this.consultarMetas();

            }
            else {
                window.showNotification(`Erro ao cadastrar: O valor total da soma dos meses deve ser igual aos valores previstos`, 'danger');
            }

        } catch(erro) {
            let mensagem = 'Erro ao cadastrar';
            if(erro.message.includes("Sigla")) mensagem = "Selecione a Linha da Atuação, Categorias e Produto para cadastrar"
            window.showNotification(mensagem, 'danger');
        }

    }

    onChange = async () => {

        let valorHora = document.getElementById("valorHora").value;
        let linha = document.getElementById("linhaAtuacao").value
        let categoria = document.getElementById("categoria").value
        
        if(linha === "Metrologia") {
            let totalLaudosRelatorios = document.getElementById("totalLaudosRelatorios").value;
            document.getElementById("receitaPrevista").value = totalLaudosRelatorios * valorHora;
        }
        else {
            let metaAtendimentos = document.getElementById("metaAtendimentos").value;
            let mediaHH = document.getElementById("mediaHH").value;
            document.getElementById("totalHH").value = metaAtendimentos * mediaHH;
            
            let totalHH = document.getElementById("totalHH").value;
            document.getElementById("receitaPrevista").value = totalHH * valorHora;
        }

        if(categoria === "Calibração" || categoria === "Ensaios") {
            utils.calculaMetaMetrologiaAutomaticamente(categoria);
        }
        else {
            utils.calculaMetaAutomaticamente();
        }

        utils.informaSomaTotalAtual();

    }

    render() {
        let unidade = this.props.match.params.unidade;
        return (
            <Fragment>
                <NomeUnidade unidade={unidade}/>
                <div className="content">
                    <FormDetalheAlt 
                        {...this.state} 
                        unidade={unidade}
                        onSubmit={this.onSubmit}
                        onChange={this.onChange}
                    />
                </div>
            </Fragment>
        )
    }
}